import React, { Component } from "react";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";

import UsersTagSuggestion from "common/UsersTagSuggestion";

import {
  setCurrentEmailCampaignData,
  initApprovalTeams,
  setProgrammedDate,
} from "actions";
import { fetchApprovalTeams } from "thunks";
import InlineToolbarEditor from "../../campaign/test/InlineToolbarEditor";
import CheckBoxBtn from "common/CheckBoxBtn";

import _ from "i18n";
import { ucFirst } from "../../../services/common";
import StepsFooter from "./StepsFooter";
import { NotificationBar } from "./notifications/NotificationBar";
import TTPSelect from "../../common/TTPSelect";
import { TeamOption } from "../../campaign/test/TeamOption";
import moment from "moment/moment";
import InputMoment from "input-moment";

const DATE_FORMAT = "DD-MM-YYYY HH:mm";
@connect((store) => {
  return {
    userEmails: store.auth.user.email,
    _requests: store.params.sourcesTokens,
    currentStep: store.currentCampaign.email.currentSideBar === "TEST",
    approvalTeams: store.currentCampaign.email.approvalTeams,
    selectedTags: store.currentCampaign.email.testEmails,
    testingDisabled: !store.currentCampaign.email.fromEmailValid,
    teams: store.approval.teams.items,
    detached: store.auth.detached,
    mandatoryTest: store.auth.currentSetting.mandatoryTest,
    autoSend: store.auth.currentSetting.autoSend,
    updating: store.currentCampaign.email.updating,
    auth: store.auth,
    programmedDate: store.currentCampaign.uaNewsletter.programmedDate,
    scheduledDeliveryAt: store.currentCampaign.email.scheduledDeliveryAt,
  };
})
export default class TestStep extends Component {
  constructor(props) {
    super(props);
    this.handleSendToChange = () =>
      this.setState({ sendTo: !this.state.sendTo });
    this.handleSendMeChange = () =>
      this.setState({ sendMe: !this.state.sendMe });
    this.toogleDetails = () =>
      this.setState({ showDetails: !this.state.showDetails });

    this.state = {
      showDetails: false,
      sendTo: false,
      sendMe: true,
      sendToApprovers: false,
      scheduleCampaign: false,
      showInputMoment: false,
      scheduledDeliveryAtState: this.props.scheduledDeliveryAt,
    };
    this.handleSendToChange = () =>
      this.setState({ sendTo: !this.state.sendTo });
    this.handleSendMeChange = () =>
      this.setState({ sendMe: !this.state.sendMe });
    this.toogleDetails = () =>
      this.setState({ showDetails: !this.state.showDetails });

    this.handleCancelSchedulingDelivery =
      this.handleCancelSchedulingDelivery.bind(this);

    this.toggleInputMoment = (showInputMoment) =>
      this.setState({ showInputMoment });
    this.toggleScheduleBlock = () => {
      this.setState({ scheduleCampaign: !this.state.scheduleCampaign });
    };
  }

  componentDidMount() {
    if (
      this.props.programmedDate != null &&
      moment(this.props.programmedDate).isValid()
    ) {
      this.setState({ scheduleCampaign: true });
    }
  }

  componentWillMount() {
    let { userEmails, dispatch } = this.props;
    let mainUserEmail = "";
    dispatch(initApprovalTeams());
    for (let i = 0; i < userEmails.length; i++) {
      if (userEmails[i]["main"] === 1) {
        mainUserEmail = userEmails[i];
        break;
      }
    }
    if (!mainUserEmail) {
      mainUserEmail = userEmails[0];
    }
    dispatch(fetchApprovalTeams());
    this.setState({ mainUserEmail });
  }

  handleCancelSchedulingDelivery() {
    const { dispatch } = this.props;
    dispatch(setCurrentEmailCampaignData({ scheduledDeliveryAt: "" }));
    this.setState({ scheduledDeliveryAtState: "" });

    this.toggleScheduleBlock();
  }

  handleScheduledDeliveryAtChange = (scheduledDeliveryAt) => {
    const { dispatch } = this.props;
    dispatch(setCurrentEmailCampaignData({ scheduledDeliveryAt }));
    dispatch(setProgrammedDate(null));
    this.setState({ scheduledDeliveryAtState: scheduledDeliveryAt });
  };
  handleApprovalTeamsChange = (teams) => {
    const { dispatch } = this.props;
    dispatch(setCurrentEmailCampaignData({ approvalTeams: teams }));
  };

  handleSendApproversChange = () => {
    let sendToApprovers = !this.state.sendToApprovers;
    this.setState({ sendToApprovers, showDetails: sendToApprovers });
  };

  handleTestClick() {
    let { onConfirm, selectedTags } = this.props;
    const { sendTo, sendMe, sendToApprovers, mainUserEmail } = this.state;
    if (sendTo && selectedTags.length === 0) {
      NotificationManager.warning(_("typeTestEmail"), _("warning"));
      return;
    }
    if (!(sendTo || sendMe || sendToApprovers)) {
      return;
    }
    let sentOptions = { sendToApprovers, sendTo, sendMe };
    if (sendMe) {
      sentOptions.email = mainUserEmail.id;
    }
    onConfirm(sentOptions);
  }

  handleTagsChange = (tags) => {
    this.props.dispatch(setCurrentEmailCampaignData({ testEmails: tags }));
  };

  renderTestBlock() {
    let {
      selectedTags,
      detached,
      teams,
      approvalTeams,
      mandatoryTest,
      autoSend,
      auth,
      plan,
    } = this.props;
    const { sendTo, sendMe, sendToApprovers, mainUserEmail, showDetails } =
      this.state;

    if (detached) {
      return (
        <div className="columns small-10">
          <span className="tab-label">
            {ucFirst(_("send me a test email"))} :
          </span>
          <span className="detail"> - {mainUserEmail.email}</span>
        </div>
      );
    }
    return (
      <div className="row">
        <div className="columns small-6 columns-padding">
          <span className="tab-label">{ucFirst(_("sendEmailTestTo"))}</span>
          <div className="small-12 flex-container align-middle m-r-xs ">
            <CheckBoxBtn
              id="send-to"
              checked={sendTo}
              onChange={this.handleSendToChange}
            />
            <UsersTagSuggestion
              displayEmail={true}
              selectedTags={selectedTags}
              onTagsChange={this.handleTagsChange}
              mainClass={`tags-input-container ${
                selectedTags && selectedTags.length ? "filled-box" : "empty-box"
              }`}
            />
          </div>
        </div>

        <div className="columns small-6 columns-padding">
          <span className="tab-label">{ucFirst(_("send me a test at"))}</span>
          <div className="small-12 flex-container align-middle">
            <CheckBoxBtn
              checked={sendMe}
              onChange={this.handleSendMeChange}
              id="send-me"
            />
            <input
              className="filled-box"
              type="text"
              value={mainUserEmail.email}
              disabled={true}
            />
          </div>
        </div>

        {(auth.currentClient?.id === 4 || plan === "PERSONALIZED") && (
          <div className="columns small-6 columns-padding">
            <div className="small-12 tab-label">
              {ucFirst(_("send to approval teams"))}
              <span className="see-more" onClick={this.toogleDetails}>
                {_(showDetails ? "see less" : "see more")}
                <i
                  className={`icon ${
                    showDetails ? "icon-arrow-up" : "icon-arrow-down"
                  }`}
                />
              </span>
            </div>
            {showDetails && (
              <div className="columns approvers-block">
                <div>
                  - {_("approval is required")} :{" "}
                  <b>{mandatoryTest ? _("yes") : _("no")}</b>
                </div>
                <div>
                  - {_("automatic sending")} :{" "}
                  <b>{autoSend ? _("yes") : _("no")}</b>
                </div>
              </div>
            )}

            <div className="small-12 flex-container align-middle m-t-xs m-r-xs ">
              <CheckBoxBtn
                checked={sendToApprovers}
                onChange={this.handleSendApproversChange}
                id="send-tester"
              />
              <TTPSelect
                simple={true}
                values={approvalTeams}
                placeholder={_("Select approval teams")}
                options={teams.filter(
                  (team) => team.members && team.members.length,
                )}
                onChange={this.handleApprovalTeamsChange}
                cssClass={
                  (!approvalTeams || !approvalTeams.length) && "empty-box"
                }
                customOption={TeamOption}
              />
            </div>
          </div>
        )}

        <div className="columns small-6 columns-padding">
          <span className="tab-label">{ucFirst(_("Add a comment"))}</span>
          <div className="small-12">
            <InlineToolbarEditor />
          </div>
        </div>
      </div>
    );
  }

  render() {
    let {
      testingDisabled,
      updating,
      approvalTeams,
      selectedTags,
      isSuccesTest,
      currentStep,
      programmedDate,
      isStepReview,
    } = this.props;
    const {
      sendTo,
      sendMe,
      sendToApprovers,
      scheduleCampaign,
      showInputMoment,
      scheduledDeliveryAtState,
    } = this.state;

    var testingEnabled =
      !testingDisabled &&
      ((sendToApprovers && approvalTeams && approvalTeams.length > 0) ||
        (sendTo && selectedTags && selectedTags.length > 0) ||
        sendMe);

    return (
      <div id="send-tabs__tab" className={`${!currentStep && "hide"}`}>
        <div className="tab">
          <h4 className="tab-header">{ucFirst(_("sendTest"))}</h4>
          {this.renderTestBlock()}
          <div className="small-12 row columns send-buttons align-center">
            <div
              className={`send-buttons__item ${
                !scheduleCampaign ? "checked" : ""
              }`}
              onClick={this.handleCancelSchedulingDelivery}
            >
              <CheckBoxBtn
                onChange={this.handleCancelSchedulingDelivery}
                label={_("Send your campaign immediately")}
                checked={!scheduleCampaign}
                labelClass={!scheduleCampaign && "checked"}
              />
            </div>
            <div
              className={`send-buttons__item ${
                scheduleCampaign ? "checked" : ""
              }`}
              onClick={this.handleCancelSchedulingDelivery}
            >
              <CheckBoxBtn
                onChange={this.toggleScheduleBlock}
                label={_("schedule_sending_campaign")}
                checked={scheduleCampaign}
                labelClass={scheduleCampaign && "checked"}
              />
            </div>

            <div
              className={`row ${
                !(scheduleCampaign || scheduledDeliveryAtState) && "hide"
              }`}
              style={{ display: "inline-block", width: "100%" }}
            >
              <input
                placeholder={_("delivery date")}
                type="text"
                value={
                  programmedDate && moment(programmedDate).isValid()
                    ? programmedDate.format(DATE_FORMAT)
                    : (scheduledDeliveryAtState &&
                        scheduledDeliveryAtState.format(DATE_FORMAT)) ||
                      ""
                }
                readOnly
                className={
                  scheduledDeliveryAtState ? "filled-box" : "empty-box"
                }
                onFocus={() => this.toggleInputMoment(true)}
              />
              <a
                className="clear text-uppercase"
                onClick={this.handleCancelSchedulingDelivery}
              >
                {_("cancel")}
              </a>
              {showInputMoment && (
                <div className="input-moment">
                  <InputMoment
                    moment={
                      programmedDate && moment(programmedDate).isValid()
                        ? programmedDate
                        : scheduledDeliveryAtState || moment()
                    }
                    onChange={this.handleScheduledDeliveryAtChange}
                    onSave={this.toggleInputMoment}
                    prevMonthIcon="icon-arrow-left"
                    nextMonthIcon="icon-arrow-right"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {isSuccesTest && <NotificationBar message={_("campaignTestSent")} />}
        <StepsFooter
          testingEnabled={testingEnabled}
          handleTestClick={this.handleTestClick.bind(this)}
          isStepReview={isStepReview}
        />
      </div>
    );
  }
}
